module.exports = __webpack_public_path__ + "static/media/Marketing.d9eda7d9.png";